<script setup>
import { useI18n } from 'vue-i18n';

const props = defineProps({
  products: { type: Array, default: () => [] },
  isLoading: { type: Boolean, default: false },
  isAdmin: { type: Boolean, default: false },
});

const emit = defineEmits(['select-product']);

const { t } = useI18n();

const formatCurrency = val =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val || 0);
</script>

<template>
  <div>
    <h3 class="text-sm font-semibold text-slate-700 dark:text-slate-200 mb-3">
      {{ t('PDV_SALES_REPORT.PRODUCT_RANKING.TITLE') }}
    </h3>
    <div v-if="isLoading" class="flex items-center justify-center py-6 text-slate-500">
      <span class="i-lucide-loader-circle animate-spin mr-2" />
    </div>
    <table v-else class="w-full text-sm text-left">
      <thead>
        <tr class="border-b border-slate-100 dark:border-slate-700">
          <th class="py-1.5 px-2 font-medium text-slate-500 dark:text-slate-400">
            {{ t('PDV_SALES_REPORT.PRODUCT_RANKING.PRODUCT') }}
          </th>
          <th class="py-1.5 px-2 font-medium text-slate-500 dark:text-slate-400">
            {{ t('PDV_SALES_REPORT.PRODUCT_RANKING.SKU') }}
          </th>
          <th class="py-1.5 px-2 font-medium text-slate-500 dark:text-slate-400 text-right">
            {{ t('PDV_SALES_REPORT.PRODUCT_RANKING.QTY') }}
          </th>
          <th class="py-1.5 px-2 font-medium text-slate-500 dark:text-slate-400 text-right">
            {{ t('PDV_SALES_REPORT.PRODUCT_RANKING.REVENUE') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(product, idx) in products"
          :key="product.product_id"
          class="border-b border-slate-50 dark:border-slate-800"
          :class="isAdmin ? 'cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-800' : ''"
          @click="isAdmin && emit('select-product', product)"
        >
          <td class="py-1.5 px-2 text-slate-700 dark:text-slate-200">
            <span class="text-xs text-slate-400 mr-1">{{ idx + 1 }}.</span>
            {{ product.name }}
            <span v-if="isAdmin" class="i-lucide-chevron-right text-slate-300 ml-1 text-xs" />
          </td>
          <td class="py-1.5 px-2 text-slate-400 text-xs">{{ product.sku }}</td>
          <td class="py-1.5 px-2 text-slate-600 dark:text-slate-300 text-right">
            {{ product.qty_sold }}
          </td>
          <td class="py-1.5 px-2 text-slate-600 dark:text-slate-300 text-right">
            {{ formatCurrency(product.total_revenue) }}
          </td>
        </tr>
        <tr v-if="!products.length">
          <td colspan="4" class="py-6 text-center text-slate-400">
            {{ $t('PDV_SALES_REPORT.NO_DATA') }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
